"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { HomeIcon, SwatchBook, UserPenIcon } from "lucide-react";
import { useI18n } from "@/lib/i18n";
import { cn } from "@/lib/utils";

const navItems = [
  {
    key: "home" as const,
    url: "/",
    icon: HomeIcon,
  },
  {
    key: "review" as const,
    url: "/review",
    icon: SwatchBook,
  },
  {
    key: "settings" as const,
    url: "/settings",
    icon: UserPenIcon,
  },
];

export default function MobileBottomNav() {
  const pathname = usePathname();
  const { t } = useI18n();
  
  const replacedPathname = pathname.split("/").filter(Boolean)[0];

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-background border-t border-border safe-area-inset-bottom rounded-t-3xl">
      <div className="flex items-center justify-around h-16 px-2">
        {navItems.map((item) => {
          const Icon = item.icon;
          const isActive = 
            (item.url === "/" && replacedPathname === undefined) ||
            item.url.replace("/", "") === replacedPathname;
          
          return (
            <Link
              key={item.key}
              href={item.url}
              className={cn(
                "flex flex-col items-center justify-center flex-1 h-full gap-1 transition-colors",
                "active:scale-95 transition-transform",
                isActive 
                  ? "text-black dark:text-white font-semibold" 
                  : "text-muted-foreground"
              )}
            >
              <Icon className={cn(
                "w-5 h-5",
                isActive && "stroke-[2.5px]"
              )} />
              <span className="text-xs">
                {t(`navigation.links.${item.key}`)}
              </span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}

